import Vue from 'vue';
import VueRouter from 'vue-router';
//import routes from './routes';
import routes from './MinaSidorRouter';

Vue.use(VueRouter);

// configure router
let locale = window.location.pathname.replace(/^\/([^\/]+).*/i, "$1");
const router = new VueRouter({
  base:
  locale.trim().length && locale != "/" && locale != "admin"
    ? "/" + locale
    : undefined,
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

export default router;
